import * as React from 'react';
import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import { ProjectServices } from '../../../../Services/ProjectServices';
import { useStyle as onboardingStyle  } from '../../../CustomerOnBoarding';
import variables from '../../../../Sys/variable.scss';

const projectServices = new ProjectServices();

const useStyles = makeStyles((theme) => ({
    inputStyle: {
        borderColor: '#838383',
        borderRadius: '25px',
    },
    pageHeader: {
        display: 'flex',
        justifyContent: 'space-between',
        margin: '25px 0'
    },
    heading: {
        color: variables.labelcolor,
        fontSize: '23px',
        fontWeight: '500'
    },
    btn: {
        padding: '13px 35px',
        background: '#3D7DDD',
        fontSize: '17px',
        color: 'white',
        borderRadius: '5px',
        marginLeft: '15px',
        "&:hover": {
            background: "#3d7ddd99"
        }
    },
    placeBtn: {
        display: 'flex',
        justifyContent: 'end',
        padding: '20px 0'
    },
    btnPwd: {
        background: '#3D7DDD',
        color: 'white',
        borderRadius: '25px',
        padding: '18px',
        marginTop: '-3px',
        marginLeft: '-42px',
        "&:hover": {
            background: "#3D7DDD"
        }
    },
    divOuter: {
        border: '1px solid #838383',
        borderRadius: 10
    },
    color: {
        color: "#373737"
    },
    summaryRow: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        gap: theme.spacing(1.5),
        [theme.breakpoints.down('sm')]: {
            flexDirection: 'column',
            alignItems: 'stretch',
        }
    },
    summaryStats: {
        padding: '15px 0 10px 10px',
        display: 'flex',
        flexWrap: 'wrap',
        gap: theme.spacing(2),
        minWidth: 0,
    },
    summaryEditBtn: {
        color: "#3D7DDD",
        borderColor: "#3D7DDD",
        borderRadius: 5,
        margin: '0 10px 10px 0',
        whiteSpace: 'nowrap',
        [theme.breakpoints.down('sm')]: {
            width: 'calc(100% - 20px)',
            margin: '0 10px 10px 10px',
        }
    },
    bottomActions: {
        marginTop: theme.spacing(2),
    },
    sameRowActions: {
        flexWrap: 'nowrap',
        justifyContent: 'center',
        [theme.breakpoints.up('md')]: {
            justifyContent: 'flex-end',
        },
    },
    sectionLoaderWrap: {
        minHeight: 280,
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    }
}));

const ProjectSummary = ({
    handleEditTab,
    handleBack,
    handleNext
}) => {

    const classes = useStyles();
    const onBorningClasses = onboardingStyle();

    const [loading, setLoading] = React.useState(false);
    const [projectSummary, setProjectSummary] = React.useState(null);

    React.useEffect(() => {
        getProjectSummary();
    }, []);

    async function getProjectSummary(){
        setLoading(true);
        const projSum = await projectServices.getProjectSummary(localStorage.getItem('project_id'));
        if(projSum && projSum.data){
            localStorage.setItem('summaryload', true);
            setProjectSummary(projSum.data);
        }
        setLoading(false);
    }

    return (
        <>
            {loading ? (
                <div className={classes.sectionLoaderWrap}>
                    <CircularProgress size={34} />
                </div>
            ) : (
                <>
            <Grid container spacing={3} style={{ marginBottom: '15px', marginTop: '15px' }}>
                <Grid item xs={12} md={4}>
                    <TextField
                        variant="outlined"
                        fullWidth
                        size="small"
                        label="Project Name *"
                        name="projectName"
                        value={projectSummary ? projectSummary.project_name : ''}
                        InputProps={{ readOnly: true }}
                    />
                </Grid>
                <Grid item xs={12} md={4}>
                    <TextField
                        variant="outlined"
                        fullWidth
                        size="small"
                        label="Company Name *"
                        name="companyName"
                        value={projectSummary ? projectSummary.company_name : ''}
                        InputProps={{ readOnly: true }}
                    />
                </Grid>
                <Grid item xs={12} md={4}>
                    <TextField
                        variant="outlined"
                        fullWidth
                        size="small"
                        label="Customer Admin *"
                        name="customerAdmin"
                        value={projectSummary ? projectSummary.customer_admin : ''}
                        InputProps={{ readOnly: true }}
                    />
                </Grid>
            </Grid>
            <Grid container spacing={3} style={{ marginBottom: '15px', marginTop: '15px' }}>
                <Grid item xs={12} md={4}>
                    <TextField
                        variant="outlined"
                        fullWidth
                        size="small"
                        label="Project Admin"
                        name="projectAdmin"
                        value={projectSummary ? projectSummary.project_admin : ''}
                        InputProps={{ readOnly: true }}
                    />
                </Grid>
                <Grid item xs={12} md={4}>
                    <TextField
                        variant="outlined"
                        fullWidth
                        size="small"
                        label="Status"
                        name="status"
                        value={projectSummary ? projectSummary.status : ''}
                        InputProps={{ readOnly: true }}
                    />
                </Grid>
            </Grid>
            <Grid container style={{ marginBottom: '15px', marginTop: '35px' }}>
                <Grid item xs={12}>
                    <div className={classes.divOuter}>
                        <Typography className={classes.color} style={{ padding: 10, borderBottom: '1px solid #838383' }}>User</Typography>
                        <Typography className={classes.color} style={{ padding: 10 }}>Total : {projectSummary ? projectSummary.total_users_count : 0}</Typography>
                        <div className={classes.summaryRow}>
                            <div className={classes.summaryStats}>
                                <Typography className={classes.color}>Customers Admin : {projectSummary ? projectSummary.company_admins_count : 0}</Typography>
                                <Typography className={classes.color}>Project Admin : {projectSummary ? projectSummary.project_admins_count : 0}</Typography>
                                <Typography className={classes.color}>User : {projectSummary ? projectSummary.remaining_users : 0}</Typography>
                            </div>
                            <Button onClick={(evt) => handleEditTab('user')} variant="outlined" className={classes.summaryEditBtn}>Edit User</Button>
                        </div>
                    </div>
                </Grid>
            </Grid>
            <Grid container style={{ marginBottom: '15px', marginTop: '35px' }}>
                <Grid item xs={12}>
                    <div className={classes.divOuter}>
                        <Typography className={classes.color} style={{ padding: 10, borderBottom: '1px solid #838383' }}>Licences</Typography>
                        <Typography className={classes.color} style={{ padding: 10 }}>Total Licence Allocated : {projectSummary ? projectSummary.total_linceses : 0}</Typography>
                        <div className={classes.summaryRow}>
                            <div className={classes.summaryStats}>
                                <Typography className={classes.color}>Assessments : {projectSummary ? projectSummary.assesment_licenses_count : 0}</Typography>
                                <Typography className={classes.color}>Courses : {projectSummary ? projectSummary.course_linceses_count : 0}</Typography>
                                <Typography className={classes.color}>Apprenticeship : {projectSummary ? projectSummary.apprenticeship_lincenses_count : 0}</Typography>
                                <Typography className={classes.color}>Labs : {projectSummary ? projectSummary.lab_licenses_count : 0}</Typography>
                            </div>
                            <Button onClick={handleBack} variant="outlined" className={classes.summaryEditBtn}>Edit Licence Allocation</Button>
                        </div>
                    </div>
                </Grid>
            </Grid>
            <div className={classes.bottomActions}>
                <div className={`${onBorningClasses.buttons} ${classes.sameRowActions}`}>
                    <div className={onBorningClasses.wrapper}>
                        <Button
                            type={"button"}
                            onClick={(evt) => handleEditTab('project')}
                            variant="contained"
                            color="primary"
                            disabled={loading}
                            className={onBorningClasses.button}
                        >
                            Create Project
                        </Button>
                        <Button
                            type={"submit"}
                            onClick={handleNext}
                            variant="contained"
                            color="primary"
                            disabled={loading}
                            className={onBorningClasses.button}
                        >
                            Finish Project
                        </Button>
                    </div>
                </div>
            </div>
                </>
            )}
        </>
    );
};

export default ProjectSummary;
